import {useProfileUpcomingOrderQuery} from '#apollo/schema';
import {Accordion, Text} from '#component/base';
import RectangleSkeleton from '#component/base/skeletons/RectangleSkeleton';
import {AccordionRoot} from '#component/util';
import {sprinkles} from '#style/sprinkles';
import {formattedDate} from '#util';
import {SubscriptionStatusEnum} from '#util/subscriptions';

import OrderDetailWithFixed from './OrderDetailWithFixed';
import OrderTotals from './OrderTotals';

import {
  accordionTriggerCustomBtn,
  accordionTriggerText,
  accordionTriggerTextInner,
  accordionWrapper,
  accordionWrapperInner,
  notUpcomingOrderWrapper,
  notUpcomingOrderWrapperText,
  orderDetailsWrapper,
  upcomingOrderHeadingText,
  upcomingOrderWrapper,
} from './UpcomingOrder.css';

const UpcomingOrder = () => {
  const {loading, data} = useProfileUpcomingOrderQuery();
  const {me} = data || {};
  const {customerAccount} = me || {};
  const {upcomingOrder, subscription} = customerAccount || {};
  const {status} = subscription || {};
  if (!upcomingOrder && status === SubscriptionStatusEnum.ACTIVE) {
    return (
      <div className={notUpcomingOrderWrapper}>
        <Text as="h1" variant="heading3" color="burgundy" className={notUpcomingOrderWrapperText}>
          You have no upcoming orders scheduled{' '}
        </Text>
      </div>
    );
  }
  return status === SubscriptionStatusEnum.ACTIVE ? (
    <div className={upcomingOrderWrapper}>
      {loading ? (
        <RectangleSkeleton width={1400} height={600} />
      ) : (
        <>
          <Text as="h1" variant="heading3" color="burgundy" className={upcomingOrderHeadingText}>
            Upcoming Order{' '}
          </Text>
          <AccordionRoot collapsible type="single" className={sprinkles({width: 'full'})}>
            <Accordion
              className={accordionWrapper}
              triggerClassName={accordionWrapperInner}
              buttonClassName={accordionTriggerCustomBtn}
              trigger={
                <Text as="p" variant="body" className={accordionTriggerText} color="mineShaft">
                  Next order to be created: {}
                  <Text variant="body" color="mineShaft" className={accordionTriggerTextInner}>
                    {upcomingOrder && formattedDate(upcomingOrder?.billingDate)}
                  </Text>
                </Text>
              }
              value="1">
              <div className={orderDetailsWrapper}>
                {upcomingOrder?.billingDate && <OrderDetailWithFixed order={{...upcomingOrder}} />}
                {upcomingOrder?.status && (
                  <OrderTotals
                    order={{
                      ...upcomingOrder,
                      taxTotal: 0,
                    }}
                  />
                )}
              </div>
            </Accordion>
          </AccordionRoot>
        </>
      )}
    </div>
  ) : null;
};

export default UpcomingOrder;
